const CompareIcon = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.4182 12.2198C20.0082 12.2198 19.6682 11.8798 19.6682 11.4698V8.1499C19.6682 6.9099 18.6582 5.8999 17.4182 5.8999H3.57812C3.16813 5.8999 2.82812 5.5599 2.82812 5.1499C2.82812 4.7399 3.16813 4.3999 3.57812 4.3999H17.4182C19.4882 4.3999 21.1682 6.0799 21.1682 8.1499V11.4698C21.1682 11.8898 20.8282 12.2198 20.4182 12.2198Z"
      fill="currentColor"
    />
    <path
      d="M6.73813 9.06998C6.54813 9.06998 6.35813 8.99995 6.20813 8.84995L3.04813 5.68997C2.90813 5.54997 2.82812 5.35994 2.82812 5.15994C2.82812 4.95994 2.90813 4.76998 3.04813 4.62998L6.20813 1.46994C6.49813 1.17994 6.97813 1.17994 7.26813 1.46994C7.55813 1.75994 7.55813 2.24 7.26813 2.53L4.63815 5.15994L7.26813 7.78995C7.55813 8.07995 7.55813 8.55995 7.26813 8.84995C7.11813 8.98995 6.92813 9.06998 6.73813 9.06998Z"
      fill="currentColor"
    />
    <path
      d="M20.4182 19.59H6.57812C4.50813 19.59 2.82812 17.91 2.82812 15.84V12.52C2.82812 12.11 3.16813 11.77 3.57812 11.77C3.98812 11.77 4.32812 12.11 4.32812 12.52V15.84C4.32812 17.08 5.33812 18.09 6.57812 18.09H20.4182C20.8282 18.09 21.1682 18.43 21.1682 18.84C21.1682 19.25 20.8282 19.59 20.4182 19.59Z"
      fill="currentColor"
    />
    <path
      d="M17.2592 22.7501C17.0692 22.7501 16.8792 22.6801 16.7292 22.5301C16.4392 22.2401 16.4392 21.7601 16.7292 21.4701L19.3592 18.8401L16.7292 16.2101C16.4392 15.9201 16.4392 15.4401 16.7292 15.1501C17.0192 14.8601 17.4992 14.8601 17.7892 15.1501L20.9492 18.3101C21.0892 18.4501 21.1692 18.6401 21.1692 18.8401C21.1692 19.0401 21.0892 19.2301 20.9492 19.3701L17.7892 22.5301C17.6492 22.6801 17.4592 22.7501 17.2592 22.7501Z"
      fill="currentColor"
    />
  </svg>
);
export default CompareIcon;
